import { useEffect, useState } from "react";

const ReusableModal = ({ open, onClose, children }) => {
  
  const [isMobile, setIsMobile] = useState(window.innerWidth < 1024);

  useEffect(() => {
    const handleResize = () => setIsMobile(window.innerWidth < 1024);
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  // Early return after hooks
  if (!open) return null;

  const modalOverlay = {
    position: "fixed",
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    backgroundColor: "rgba(0,0,0,0.7)",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    zIndex: 1050,
    width: "100vw",
    height: "100vh",
  };

  const modalContent = {
    background: "#fff",
    borderRadius: "12px",
    padding: isMobile ? "1.5rem" : "2rem",
    width: isMobile ? "90vw" : "500px",
    maxHeight: "85vh",
    overflowY: "auto",
    position: "relative",
  };

  const closeBtn = {
    position: "absolute",
    top: "12px",
    right: "12px",
    background: "none",
    border: "none",
    fontSize: "28px",
    color: "#333",
    cursor: "pointer",
  };

  return (
    <div style={modalOverlay} onClick={(e) => e.target === e.currentTarget && onClose()}>
      <div style={modalContent}>
        <button style={closeBtn} onClick={onClose}>×</button>
        {children}
      </div>
    </div>
  );
};

export default ReusableModal;
